<script setup lang="ts">
/**
 * Second facteur d'un admin qui a enregistre une passkey : le premier facteur
 * (mot de passe ou code) est valide, la session ne s'ouvre qu'apres elle.
 */
const emit = defineEmits<{
  success: []
}>()

const store = useAuthStore()
const toast = useToast()
const loading = ref(false)

async function valider() {
  loading.value = true
  try {
    await store.verifyPasskey()
    emit('success')
  }
  catch (err) {
    // Fenetre du navigateur fermee ou delai depasse : pas une erreur serveur
    const name = (err as { name?: string }).name
    const message = name === 'NotAllowedError' || name === 'AbortError'
      ? 'Validation annulée. Réessayez avec votre passkey.'
      : (err as { data?: { message?: string } }).data?.message || 'Passkey refusée, réessayez.'
    toast.add({ title: 'Passkey', description: message, color: 'error' })
  }
  finally {
    loading.value = false
  }
}
</script>

<template>
  <div class="space-y-4">
    <UAlert
      color="info"
      variant="subtle"
      icon="i-lucide-fingerprint"
      title="Validation par passkey"
      description="Votre compte administrateur est protégé par une passkey. Validez avec votre empreinte, votre visage, votre clé de sécurité ou votre téléphone."
    />

    <UButton
      block
      size="lg"
      color="secondary"
      icon="i-lucide-key-round"
      :loading="loading"
      @click="valider"
    >
      Valider avec ma passkey
    </UButton>
  </div>
</template>
